/* istanbul ignore file */
export const CIDI_DASHBOARD_API_URL = process.env.VUE_APP_DASHBOARD_CIDI_API_URL || '';
export const CIDT_DASHBOARD_API_URL = process.env.VUE_APP_DASHBOARD_CIDT_API_URL || '';
export const CIDT_DASHBOARD_ACCOUNTS_API_URL = process.env.VUE_APP_DASHBOARD_CIDT_ACCOUNTS_API_URL || '';
export const CI_MAIN_URL = process.env.VUE_APP_CI_MAIN_SITE_URL || '';
export const MICR_URL = process.env.VUE_APP_MICR_URL || '';
